/**
 * Same options as Invoice Settings: labels are short; values match API / DB (e.g. Net 30).
 */
export const INVOICE_PAYMENT_TERM_OPTIONS = [
  { label: "Upon Receipt", value: "Upon Receipt" },
  { label: "15", value: "Net 15" },
  { label: "30", value: "Net 30" },
  { label: "45", value: "Net 45" },
  { label: "60", value: "Net 60" },
];

export const INVOICE_PAYMENT_DUE_CUSTOM = "Custom Days";

/** Map legacy invoice UI / old DB strings to canonical terms. */
export function normalizeInvoicePaymentDue(raw) {
  if (raw == null || raw === "") return "";
  const s = String(raw).trim();
  const legacy = {
    "15 Days": "Net 15",
    "30 Days": "Net 30",
    "45 Days": "Net 45",
    "60 Days": "Net 60",
  };
  if (legacy[s]) return legacy[s];
  if (s === "Custom") return INVOICE_PAYMENT_DUE_CUSTOM;
  if (/^net\s*15$/i.test(s)) return "Net 15";
  if (/^net\s*30$/i.test(s)) return "Net 30";
  if (/^net\s*45$/i.test(s)) return "Net 45";
  if (/^net\s*60$/i.test(s)) return "Net 60";
  if (s === "Upon Receipt") return "Upon Receipt";
  if (s === INVOICE_PAYMENT_DUE_CUSTOM) return INVOICE_PAYMENT_DUE_CUSTOM;
  return s;
}

export function netTermDays(term) {
  const t = normalizeInvoicePaymentDue(term) || "";
  if (t === "Net 15") return 15;
  if (t === "Net 30") return 30;
  if (t === "Net 45") return 45;
  if (t === "Net 60") return 60;
  return 0;
}
